import { darkColors } from '@tryhackme/thm-ui-components';
import { ThemeProvider, useTheme } from 'styled-components';
import { Countdown } from '../../components/countdown';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { StyledCard, StyledTimerMessage, StyledTitle } from './summer-deal-account-card.styles';
export const SummerDealAccountCard = () => {
  const theme = useTheme();
  const {
    campaign
  } = useActiveCampaign();
  if (!campaign) return null;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="SummerDealAccountCard" data-sentry-source-file="summer-deal-account-card.tsx">
      <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="summer-deal-account-card.tsx">
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="summer-deal-account-card.tsx">
          SUMMER DEAL: <span>{campaign.amount}% OFF</span> ANNUAL SUBSCRIPTIONS
        </StyledTitle>
        <StyledTimerMessage data-sentry-element="StyledTimerMessage" data-sentry-source-file="summer-deal-account-card.tsx">Sale ends in:</StyledTimerMessage>
        <Countdown includeDays dark vertical startTime={campaign.startTime} endTime={campaign.endTime} data-sentry-element="Countdown" data-sentry-source-file="summer-deal-account-card.tsx" />
      </StyledCard>
    </ThemeProvider>;
};